export default "__VITE_ASSET__DxMSJt7N__"